import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/components/login.component';
import { AuthenticationGuard } from '@app/guards/authentication.guard';
import { LoggedInGuard } from '@app/guards/logged-in.guard';
import { RegisteredGuard } from '@app/guards/registered.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/main.module').then(m => m.MainModule),
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoggedInGuard],
  },
  {
    path: 'reset-password',
    loadChildren: () => import('app/reset-password/reset-password.module').then(m => m.ResetPasswordModule),
  },
  {
    path: '**',
    redirectTo: 'ecommerce',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [LoggedInGuard, RegisteredGuard, AuthenticationGuard],
})
export class AppRoutingModule {
}

